module.exports = __webpack_public_path__ + "static/img/depto.9129bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/depto.png
// module id = e6tT
// module chunks = 5